import { createValidationSchema, emailField, PosixDate, stringField, uuidField, } from "@for-it/domain-lib";
import { TenantEntity } from "../../entities/tenant.js";
import { TenantNotFoundError } from "../../errors/tenant-not-found-error.js";
export const updateTenant = {
    name: "updateTenant",
    description: "Updates editable fields of a tenant (organizationName, contactEmail, customDomain, plan)",
    type: "command",
    isAuthRequired: true,
    payloadSchema: createValidationSchema({
        id: uuidField({
            required: true,
            message: "Debe ingresar un ID válido",
        }),
        organizationName: stringField({
            required: false,
            message: "El nombre de la organización es opcional",
        }),
        contactEmail: emailField({
            required: false,
            message: "El email de contacto debe ser válido",
        }),
        customDomain: stringField({
            required: false,
            message: "El dominio personalizado es opcional",
        }),
        plan: stringField({
            required: false,
            message: "El plan es opcional",
        }),
    }),
    useCase: async ({ db }, { id, organizationName, contactEmail, customDomain, plan, }) => {
        const tenant = await db.findOne(TenantEntity, { where: { id } });
        if (!tenant)
            return new TenantNotFoundError();
        const updated = {
            ...tenant,
            organizationName: organizationName ?? tenant.organizationName,
            contactEmail: contactEmail ?? tenant.contactEmail,
            customDomain: customDomain === undefined ? tenant.customDomain : customDomain,
            plan: plan === undefined ? tenant.plan : plan,
            updatedAt: new PosixDate(Date.now()),
        };
        await db.save(TenantEntity, updated);
        return updated;
    },
};
